import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FarmerService } from 'src/app/services/farmer.service';
import { DealerpremisesverificationpopupComponent } from './dealerpremisesverificationpopup.component';

const routes: Routes = [
  {
    path: '',
    component: DealerpremisesverificationpopupComponent
  },
]

@NgModule({
  declarations: [],
  providers: [
    FarmerService,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatCheckboxModule,
    MatInputModule,
  ],
})
export class dealerPremisesVerificationPopupModule { }
